import { Factory } from '../Factory';
import { Service } from '../Service';

namespace app.services.collections {

  import IFilterService = angular.IFilterService;

  export class CollectionService extends Service<any> {
    private currentCollection: Collection;

    constructor(resource: angular.resource.IResourceService, rootScope: IRootScope, filter: IFilterService, configService: app.services.IConfigService, private preferenceService: PreferenceService, resourceWrapperService: app.services.utilities.ResourceWrapperService) {
      super({resource, rootScope, filter, resourceWrapperService});

      let collectionResource = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/collection/:id`,
        {id: "@id", projectId: "@projectId"},
        {
          update: {method: "PUT"}
        }
      );

      this.itemResource = this.resourceWrapperService.WrapActions(collectionResource);

      this.rootScope.$on("clearCurrentSelected", () => {
        this.ClearCurrentCollection();
        if (this.items) {
          this.items.length = 0;
        }
      });


      this.RegisterCompleteEventListener("FeedService.ProcessingEnd", async (event, message) => {
        return this.FindOne({
          id: message.id,
          projectId: message.projectId
        });
      });


      this.RegisterUpdateEventListener("FeedService.CollectionUpdate", async (event, message) => {
        const item = await this.FindOne({id: message.collectionId, projectId: message.projectId});

        return {
          ...item,
          status: message.status,
          numQueued: message.numQueued,
          numProcessed: message.numProcessed,
          bytesProcessed: message.bytesProcessed,
          processingSource: message.processingSource,
          processingOutput: message.processingOutput,
          job: {...item.job, percentageComplete: message.percentageComplete},
          pdfQueued: message.pdfQueued,
          ocrQueued: message.ocrQueued,
          audioQueued: message.audioQueued
        } as any;
      });
    }

    public SetCurrentCollection(collection: Collection) {
      this.currentCollection = collection;
      this.rootScope.$broadcast("CollectionService.CurrentCollectionChanged", this.currentCollection);
    }

    public ClearCurrentCollection() {
      this.currentCollection = null;
      this.rootScope.$broadcast("CollectionService.CurrentCollectionChanged", this.currentCollection);
    }

    public GetCurrentCollection() {
      return this.currentCollection;
    }

    public CacheCollections(collections: ICollection[]) {
      this.items = collections.map(c => this.AsResource(c));
    }

    protected FindMethodCustomProcessing(item: any) {
      if (this.preferenceService.IsCollectionSelected(item)) {
        item.checked = true;
      }
    }
  }

  frontendApp.factory("CollectionService", ["$resource", "$rootScope", "$filter", "ConfigService", "PreferenceService", "ResourceWrapperService", Factory.Create(CollectionService)]);
}
